// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_20Pj1VE"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Modal/Backdrop.css
// module id = ./template/components/Modal/Backdrop.css
// module chunks = client.sitechrome